import Layout from '../../components/feature/Layout';
import Services from '../home/components/Services';
import SEO from '../../components/feature/SEO';

const serviciosJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: 'Servicios HSE - SafeLine Solutions',
  url: `${import.meta.env.VITE_SITE_URL ?? ''}/servicios`,
  description: 'Conoce todos los servicios HSE de SafeLine Solutions: gestión documental, auditorías, asesoría en terreno, sistemas de gestión y capacitación preventiva en Latinoamérica.',
  breadcrumb: {
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'Inicio', item: `${import.meta.env.VITE_SITE_URL ?? ''}/` },
      { '@type': 'ListItem', position: 2, name: 'Servicios', item: `${import.meta.env.VITE_SITE_URL ?? ''}/servicios` },
    ],
  },
  mainEntity: {
    '@type': 'ItemList',
    name: 'Servicios HSE',
    itemListElement: [
      { '@type': 'ListItem', position: 1, item: { '@type': 'Service', name: 'Gestión Documental HSE', url: `${import.meta.env.VITE_SITE_URL ?? ''}/gestion-documental` } },
      { '@type': 'ListItem', position: 2, item: { '@type': 'Service', name: 'Auditorías HSE', url: `${import.meta.env.VITE_SITE_URL ?? ''}/auditorias` } },
      { '@type': 'ListItem', position: 3, item: { '@type': 'Service', name: 'Asesoría en Terreno', url: `${import.meta.env.VITE_SITE_URL ?? ''}/asesoria-terreno` } },
      { '@type': 'ListItem', position: 4, item: { '@type': 'Service', name: 'Sistemas de Gestión ISO', url: `${import.meta.env.VITE_SITE_URL ?? ''}/sistemas-gestion` } },
      { '@type': 'ListItem', position: 5, item: { '@type': 'Service', name: 'Capacitación Preventiva', url: `${import.meta.env.VITE_SITE_URL ?? ''}/capacitacion` } },
    ],
  },
};

export default function ServiciosPage() {
  return (
    <Layout>
      <SEO
        title="Servicios HSE | SafeLine Solutions - Consultoría en Seguridad"
        description="Conoce todos los servicios HSE de SafeLine Solutions: gestión documental, auditorías, asesoría en terreno, sistemas de gestión y capacitación preventiva en Latinoamérica."
        keywords="servicios HSE, consultoría seguridad, auditorías HSE, gestión documental, capacitación preventiva"
        canonical="/servicios"
        jsonLd={serviciosJsonLd}
      />
      <div className="pt-20">
        <Services />
      </div>
    </Layout>
  );
}
